var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"w-100 h-100"},[_c('bar',{key:_vm.chartKey,staticClass:"h-100",attrs:{"chart-data":_vm.chartData,"chart-options":_vm.chartOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }